<template>
  <h3 style="text-align: center" v-if="!isOk">
   {{message}}
  </h3>
  <div class="py-4 container-fluid w-100">
    <div class="text-center message" style="fontsize: 30px">
      {{ text }}
    </div>
  </div>
</template>

<style scoped>
.message {
  font-size: 2em;
  font-weight: bold;
}
</style>

<script>
import { SendGETServerAPI } from "@/customFunctions/Api.js";
import { Toaster } from "@/customFunctions/Utils.js";

export default {
  name: "data-pipeline-transformation-market-source",
  data() {
    return {
      isOk: false,
      origin: window.location.origin,
      text:""
    };
  },
  async mounted() {
    console.log(this.$route.params.pathMatch, "aa");
    const pathMatch = this.$route.params.pathMatch[0].toLowerCase();

    const url = pathMatch === "parsebyterm" ? "parsebyterm" : "termparsetest";
    this.$store.commit("setShowPreloader", true);
    const termParam = this.getQueryStringParameter("term") ?? "";

    try {
      const resp = await SendGETServerAPI(
        `dataPipelineTransformation/${url}?term=${termParam}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      );

      if (resp.isOk) this.Toaster("", "Success", "success");
      else this.Toaster("", "Error", "danger");
      this.isOk = resp.isOk;
      this.text = resp.message;
    } catch (ex) {
      console.log(ex, "TestTermPage");
    }
    this.$store.commit("setShowPreloader", false);
  },
  methods: {
    getQueryStringParameter(parameter) {
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);

      if (urlParams.has(parameter)) {
        return urlParams.get(parameter);
      }

      return null;
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
